export default "__VITE_ASSET__CU0Kzg6E__"